import * as actions from 'redux/constants';
import { getDefaultMessages, iframeMessages } from 'services/iframeService';
import { HOSTED_PAGE_TYPES } from 'consts';

const {
  sendGetPageFailMsg: sendGetIssuingPageFail,
  sendStartMsg: sendStartMessageIssuing,
  sendSuccessMsg: sendSuccessMessageIssuing,
  sendFailMsg: sendFailMessageIssuing
} = getDefaultMessages(HOSTED_PAGE_TYPES.cardIssuing);

const issuingMiddleware = store => next => action => {
  const {
    global: { isSdk }
  } = store.getState();
  if (!isSdk) {
    return next(action);
  }

  switch (action.type) {
    case actions.GET_ISSUED_PAGE_DATA_FAIL: {
      sendGetIssuingPageFail(action.payload.error);
      break;
    }
    case actions.GET_ISSUED_CARD_START: {
      sendStartMessageIssuing();
      break;
    }
    case actions.GET_ISSUED_CARD_SUCCESS: {
      if (action.meta.muteEvent) return;
      sendSuccessMessageIssuing({
        eventType: iframeMessages.ISSUING_GET_ISSUED_CARD_SUCCESS,
        data: {}
      });
      break;
    }
    case actions.GET_ISSUED_CARD_FAIL: {
      sendFailMessageIssuing({
        eventType: iframeMessages.ISSUING_GET_ISSUED_CARD_FAIL,
        error: action.payload.error,
        meta: { closeIframe: true }
      });
      break;
    }
    case actions.SET_ISSUED_CARD_AS_EXPIRED: {
      sendSuccessMessageIssuing({
        eventType: iframeMessages.ISSUING_ISSUED_CARD_EXPIRED,
        data: {},
        meta: { closeIframe: true }
      });
      break;
    }
  }

  next(action);
};

export default issuingMiddleware;
